import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { useEffect, useRef, useState } from 'react'
import moment from "moment"

import '../../../styles/reports/reports-common.scss';
import { enterFunctionV2, focusElement, handlekeyDown } from '../../../components/generics/helper';
import BrandAutocomplete from '../../../components/formik-form-components/BrandAutocomplete';
import CategoryAutocomplete from '../../../components/formik-form-components/CategoryAutocomplete';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import DatepickerV2 from '../../../components/shared/DatepickerV2';
import ItemAutocomplete from '../../../components/formik-form-components/ItemAutocomplete';
import ItemIssueRegisterReportDetailList from "./ItemIssueRegisterReportDetailList";
import ItemIssueRegisterReportSummaryList from "./ItemIssueRegisterReportSummaryList";
import ReportViewAutocomplete from '../../../components/formik-form-components/ReportViewAutocomplete';
import StoreAutocomplete from '../../../components/formik-form-components/StoreAutocomplete';
import VehicleAutocomplete from "../../../components/formik-form-components/VehicleAutocomplete";
import VehicleBrandAutoComplete from "../../../components/formik-form-components/VehicleBrandAutoComplete";
import VehicleModelAutoComplete from "../../../components/formik-form-components/VehicleModelAutoComplete";

const ItemIssueRegisterReport = () => {
    const filterInitialValue = { fromDate: moment(new Date()).format("YYYY-MM-DD"), toDate: moment(new Date()).format("YYYY-MM-DD"), searchCategoryIds: '', searchCategoryNames: [], searchSuperCategory: '', searchSubCategoryIds: '', searchSubCategoryNames: [], searchBrandIds: '', searchBrandNames: [], searchItemIds: '', searchItemNames: [], searchVehBrandId: '', searchVehBrandName: [], searchVehModelId: '', searchVehModelName: [], searchVehId: '', searchVehNo: [], searchStoreIds: '', searchStoreNames: [], searchReportingView: '1', searchReportViewName: 'Summary View', showOnlyPurchaseItems: "Y", showTable: false, dateType: "I" };
    const [itemIssueReportFilters, setItemIssueReportFilters] = useState(filterInitialValue);
    const [resetDate, setResetDate] = useState(false);
    const [loadData, setLoadData] = useState(false);

    const itemFilterRef = useRef(null);
    const categoryFilterRef = useRef(null);
    const subCategoryFilterRef = useRef(null);
    const brandFilterRef = useRef(null);
    const vehicleOEMFilterRef = useRef(null);
    const vehicleModelFilterRef = useRef(null);
    const vehicleNoFilterRef = useRef(null);
    const issueByStoreFilterRef = useRef(null);
    const reportTypeFilterRef = useRef(null);

    const itemIssueReportFilterReset = () => {
        setItemIssueReportFilters({ ...filterInitialValue });
        itemFilterRef.current.resetAutocomplete();
        categoryFilterRef.current.resetAutocomplete();
        subCategoryFilterRef.current.resetAutocomplete();
        brandFilterRef.current.resetAutocomplete();
        vehicleOEMFilterRef.current.resetAutocomplete();
        vehicleModelFilterRef.current.resetAutocomplete();
        vehicleNoFilterRef.current.resetAutocomplete();
        issueByStoreFilterRef.current.resetAutocomplete();
        reportTypeFilterRef.current.resetAutocomplete();
        setResetDate(true);
    }

    const generateItemIssueReportData = () => {
        setItemIssueReportFilters((prev) => ({ ...prev, showTable: true }))
        setLoadData(true);
    }
    useEffect(() => {
        focusElement('itemIssueFromDate')
    }, [])

    return (
        <>
            <div key="iir_wrapper" className="report--wrapper">
                <div key="iir_filter_wrapper" className="report--filter--wrapper itemissue--report--filter">
                    <div className="fuel--voucher--radio--wrap">
                        <FormControl >
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                value={itemIssueReportFilters.dateType}
                                onChange={(e) => setItemIssueReportFilters({ ...itemIssueReportFilters, dateType: e.target.value })}
                                className="retrieve--by--filter--options--container"
                            >
                                <FormControlLabel
                                    value="J"
                                    id="jobcardDate"
                                    style={{ fontWeight: '600 !important' }}
                                    control={<Radio />}
                                    label="Jobcard Date"
                                    onKeyDown={(e) => enterFunctionV2(e, 'issueDate', '')}
                                />
                                <FormControlLabel
                                    value="I"
                                    id="issueDate"
                                    control={<Radio />}
                                    label="Issue Date"
                                    onKeyDown={(e) => enterFunctionV2(e, 'itemIssueFromDate', 'jobcardDate')}
                                />
                            </RadioGroup>
                        </FormControl>
                    </div>
                    <div key="iir_filter_inp_container" className="input--container">
                        <DatepickerV2
                            name={'filter_from_dt'}
                            type="filter_from_dt"
                            className=""
                            star={true}
                            label={itemIssueReportFilters.dateType === 'J' ? "From Jobcard Date" : "From Issue Date"}
                            id="itemIssueFromDate"
                            Reset={resetDate}
                            dateChange={(newValue) => {
                                setResetDate(false);
                                setItemIssueReportFilters(previousFilters => ({ ...previousFilters, fromDate: moment(newValue).format("YYYY-MM-DD"), showTable: false }));
                                focusElement("itemIssueToDate")
                            }}
                        />
                    </div>
                    <div key="iir_filter_inp_tod" className="input--container" >
                        <DatepickerV2
                            name={'filter_to_dt'}
                            type="filter_to_dt"
                            className=""
                            star={true}
                            enableFuture={true}
                            emptyField={''}
                            label={itemIssueReportFilters.dateType === 'J' ? "To Jobcard Date" : "To Issue Date"}
                            fromDate={itemIssueReportFilters?.fromDate}
                            id="itemIssueToDate"
                            Reset={resetDate}
                            dateChange={(newValue) => {
                                setResetDate(false);
                                setItemIssueReportFilters(previousFilters => ({ ...previousFilters, toDate: moment(newValue).format("YYYY-MM-DD"), showTable: false }));
                                focusElement("searchIIRCategoryIds")
                            }}
                        />
                    </div>
                    <div key="iir_filter_inp_category" className="input--container" style={{ width: '10%' }}>
                        <CategoryAutocomplete
                            id="searchIIRCategoryIds"
                            name="searchIIRCategoryIds"
                            nextId="searchIIRSubCategoryIds"
                            prevId="itemIssueToDate"
                            label="Category"
                            isCompulsory={false}
                            singleSelect={false}
                            listWidth={250}
                            searchPlaceholder="Search By Category"
                            noDataLabel="No Category Found"
                            categoryFor={1}
                            isParent="Y"
                            selectedValues={itemIssueReportFilters.searchCategoryIds !== '' ? [itemIssueReportFilters.searchCategoryIds] : []}
                            onSelect={(selectedCategory, currentSelection) => {
                                const searchCategoryIds = selectedCategory.map((v) => v.categoryId).sort().join(',');
                                const searchSuperCategory = selectedCategory.length > 0 ? selectedCategory[0].superCategory : '';
                                const searchCategoryNames = selectedCategory.map((c) => c.categoryTitle).sort();
                                setItemIssueReportFilters(previousFilters => ({ ...previousFilters, searchCategoryIds, searchSuperCategory, searchCategoryNames, showTable: false }));
                            }}
                            onRemove={(selectedCategory, currentSelection) => {
                                const searchCategoryIds = selectedCategory.map((v) => v.categoryId).sort().join(',');
                                const searchSuperCategory = selectedCategory.length > 0 ? selectedCategory[0].superCategory : '';
                                const searchCategoryNames = selectedCategory.map((c) => c.categoryTitle).sort();
                                setItemIssueReportFilters(previousFilters => ({ ...previousFilters, searchCategoryIds, searchSuperCategory, searchCategoryNames, showTable: false }));
                            }}
                            ref={categoryFilterRef}
                        />
                    </div>
                    <div key="iir_filter_inp_subCategory" className="input--container">
                        <CategoryAutocomplete
                            name="searchIIRSubCategoryIds"
                            nextId="searchIIRBrandIds"
                            prevId="searchIIRCategoryIds"
                            id="searchIIRSubCategoryIds"
                            isCompulsory={false}
                            singleSelect={false}
                            listWidth={250}
                            label="Sub Category"
                            searchPlaceholder="Search By Sub Category"
                            noDataLabel="No Sub Category Found"
                            categoryFor={1}
                            isParent="N"
                            selectedValues={itemIssueReportFilters.searchSubCategoryIds !== '' ? [itemIssueReportFilters.searchSubCategoryIds] : []}
                            onSelect={(selectedSubCategory, currentSelection) => {
                                const searchSubCategoryIds = selectedSubCategory.map((v) => v.categoryId).sort().join(',');
                                const searchSubCategoryNames = selectedSubCategory.map((sc) => sc.categoryTitle).sort();
                                setItemIssueReportFilters(previousFilters => ({ ...previousFilters, searchSubCategoryIds, searchSubCategoryNames, showTable: false }));
                            }}
                            onRemove={(selectedSubCategory, currentSelection) => {
                                const searchSubCategoryIds = selectedSubCategory.map((v) => v.categoryId).sort().join(',');
                                const searchSubCategoryNames = selectedSubCategory.map((sc) => sc.categoryTitle).sort();
                                setItemIssueReportFilters(previousFilters => ({ ...previousFilters, searchSubCategoryIds, searchSubCategoryNames, showTable: false }));
                            }}
                            ref={subCategoryFilterRef}
                        />

                    </div>
                    <div key="iir_filter_inp_brand" className="input--container" style={{ width: '10%' }}>
                        <BrandAutocomplete
                            id={'searchIIRBrandIds'} nextId="searchIIRItemIds" prevId="searchIIRSubCategoryIds"
                            name="searchIIRBrandIds"
                            label="Brand"
                            searchPlaceholder="Search By Brand Category"
                            noDataLabel="No Brand Found"
                            isCompulsory={false}
                            singleSelect={false}
                            listWidth={250}
                            selectedValues={itemIssueReportFilters.searchBrandIds !== '' ? [itemIssueReportFilters.searchBrandIds] : ['']}
                            onSelect={(selectedBrands, currentSelection) => {
                                const searchBrandIds = selectedBrands.map((v) => v.brandId).sort().join(',');
                                const searchBrandNames = selectedBrands.map((b) => b.brandName).sort();
                                setItemIssueReportFilters(previousFilters => ({ ...previousFilters, searchBrandIds, searchBrandNames, showTable: false }));
                            }}
                            onRemove={(selectedBrands, currentSelection) => {
                                const searchBrandIds = selectedBrands.map((v) => v.brandId).sort().join(',');
                                const searchBrandNames = selectedBrands.map((b) => b.brandName).sort();
                                setItemIssueReportFilters(previousFilters => ({ ...previousFilters, searchBrandIds, searchBrandNames, showTable: false }));
                            }}
                            ref={brandFilterRef}
                        />
                    </div>
                    <div key="iir_filter_inp_item" className="input--container" style={{ width: '14%' }} >
                        <ItemAutocomplete
                            id="searchIIRItemIds" nextId="searchIIRVehOEMIds" prevId="searchIIRBrandIds"
                            name="searchIIRItemIds"
                            label={"Item Name & Part No."}
                            searchPlaceholder={"Search By Item Name & Part No."}
                            noDataLabel={"No Item Found"}
                            isCompulsory={false}
                            singleSelect={false}
                            listWidth={380}
                            forAllItems={'Y'}
                            onlyLoginBranchMappedModelsItems={true}
                            selectedValues={itemIssueReportFilters.searchItemIds !== '' ? [itemIssueReportFilters.searchItemIds] : []}
                            onSelect={(selectedItems) => {
                                const searchItemIds = selectedItems.map((i) => i.itemId).sort().join(',');
                                const searchItemNames = selectedItems.map(i => i.itemName);
                                setItemIssueReportFilters(previousFilters => ({ ...previousFilters, searchItemIds, searchItemNames, showTable: false }));
                            }}
                            onRemove={(selectedItems) => {
                                const searchItemIds = selectedItems.map((i) => i.itemId).sort().join(',');
                                const searchItemNames = selectedItems.map(i => i.itemName);
                                setItemIssueReportFilters(previousFilters => ({ ...previousFilters, searchItemIds, searchItemNames, showTable: false }));
                            }}
                            ref={itemFilterRef}
                        />
                    </div>
                    <div className="input--container" style={{ width: '19%' }}>
                        <VehicleBrandAutoComplete
                            name="searchIIRVehOEMIds"
                            id="searchIIRVehOEMIds" nextId="searchIIRVehModelIds" prevId="searchIIRItemIds"
                            isCompulsory={false}
                            singleSelect={false}
                            label={"Bus OEM"}
                            searchPlaceholder={"Search By Veh OEM"}
                            noDataLabel={"No Vehicle OEM Found"}
                            listWidth={260}
                            selectedValues={itemIssueReportFilters?.searchVehBrandId !== '' ? itemIssueReportFilters.searchVehBrandId.split(',') : []}
                            onSelect={(selectedOptions) => {
                                const searchVehBrandId = selectedOptions.map(option => option.vehicleOemId).join(',') || '';
                                const searchVehBrandName = selectedOptions.map(option => option.vehicleOemName);
                                setItemIssueReportFilters(prev => ({ ...prev, searchVehBrandId, searchVehBrandName, showTable: false, }));
                            }}
                            onRemove={(selectedOptions) => {
                                const searchVehBrandId = selectedOptions.map(option => option.vehicleOemId).join(',') || '';
                                const searchVehBrandName = selectedOptions.map(option => option.vehicleOemName);
                                setItemIssueReportFilters(prev => ({ ...prev, searchVehBrandId, searchVehBrandName, showTable: false, }));
                            }}
                            onlyVehicleLoginBranchMappedOems={true}
                            ref={vehicleOEMFilterRef}
                        />
                    </div>
                    <div className="input--container">
                        <VehicleModelAutoComplete
                            name="searchIIRVehModelIds"
                            id="searchIIRVehModelIds" nextId="searchIIRVehNoIds" prevId="searchIIRVehOEMIds"
                            isCompulsory={false}
                            singleSelect={false}
                            label={"Bus Model"}
                            searchPlaceholder={"Search By Vehicle Model"}
                            noDataLabel={"No Vehicle Model Found"}
                            listWidth={350}
                            selectedValues={itemIssueReportFilters?.searchVehModelId !== '' ? itemIssueReportFilters.searchVehModelId.split(',') : []}
                            onSelect={(selectedOptions) => {
                                const searchVehModelId = selectedOptions.map(option => option.vehicleModelId).join(',') || '';
                                const searchVehModelName = selectedOptions.map(option => option.vehicleModelName);
                                setItemIssueReportFilters(prev => ({ ...prev, searchVehModelId, searchVehModelName, showTable: false, }));
                            }}
                            onRemove={(selectedOptions) => {
                                const searchVehModelId = selectedOptions.map(option => option.vehicleModelId).join(',') || '';
                                const searchVehModelName = selectedOptions.map(option => option.vehicleModelName);
                                setItemIssueReportFilters(prev => ({ ...prev, searchVehModelId, searchVehModelName, showTable: false, }));
                            }}
                            onlyVehicleLoginBranchMappedModels={true}
                            forOem={itemIssueReportFilters?.searchVehBrandId}
                            ref={vehicleModelFilterRef}
                        />
                    </div>
                    <div className="input--container">
                        <VehicleAutocomplete
                            name="searchIIRVehNoIds"
                            id="searchIIRVehNoIds" nextId="searchIIRStoreIds" prevId="searchIIRVehModelIds"
                            isCompulsory={false}
                            singleSelect={false}
                            label={"Bus Number"}
                            searchPlaceholder={"Search By Vehicle Number"}
                            noDataLabel={"No Vehicle Found"}
                            listWidth={320}
                            onlyLoginBranchAppVehicles='Y'
                            selectedValues={itemIssueReportFilters?.searchVehId ? itemIssueReportFilters.searchVehId.split(',') : []}
                            onSelect={(selectedVehicles, currentSelection) => {
                                const searchVehId = selectedVehicles.map((v) => v.vehicleId).sort().join(',');
                                const searchVehNo = selectedVehicles.map((v) => v.vehicleNo).sort();
                                setItemIssueReportFilters(previousFilters => ({ ...previousFilters, searchVehId, searchVehNo, showTable: false }));
                            }}
                            onRemove={(selectedVehicles, currentSelection) => {
                                const searchVehId = selectedVehicles.map((v) => v.vehicleId).sort().join(',');
                                const searchVehNo = selectedVehicles.map((v) => v.vehicleNo).sort();
                                setItemIssueReportFilters(previousFilters => ({ ...previousFilters, searchVehId, searchVehNo, showTable: false }));
                            }}
                            forOem={itemIssueReportFilters?.searchVehBrandId}
                            forModel={itemIssueReportFilters?.searchVehModelId}
                            ref={vehicleNoFilterRef}
                        />
                    </div>
                    <div className="input--container" style={{ width: '10%' }}>
                        <StoreAutocomplete
                            id={'searchIIRStoreIds'} nextId="searchIIRReportTypeIds" prevId="searchIIRVehNoIds"
                            name={'searchIIRStoreIds'}
                            isCompulsory={false}
                            singleSelect={false}
                            label={"Issue By Store"}
                            listWidth={300}
                            selectedValues={itemIssueReportFilters.searchStoreIds !== '' ? [itemIssueReportFilters.searchStoreIds] : ['']}
                            onSelect={(selectedStores) => {
                                const searchStoreIds = selectedStores.map((s) => s.storeId).sort().join(',');
                                const searchStoreNames = selectedStores.map((b) => b.storeDisplayName).sort();
                                setItemIssueReportFilters(previousFilters => ({ ...previousFilters, searchStoreIds: searchStoreIds, searchStoreNames: searchStoreNames, showTable: false }));
                            }}
                            onRemove={(selectedStores) => {
                                const searchStoreIds = selectedStores.map((s) => s.storeId).sort().join(',');
                                const searchStoreNames = selectedStores.map((b) => b.storeDisplayName).sort();
                                setItemIssueReportFilters(previousFilters => ({ ...previousFilters, searchStoreIds: searchStoreIds, searchStoreNames: searchStoreNames, showTable: false }));
                            }}
                            ref={issueByStoreFilterRef}
                        />
                    </div>
                    <div className="input--container" >
                        <ReportViewAutocomplete
                            id="searchIIRReportTypeIds" nextId="iirShowOnlyPurchaseItems" prevId="searchIIRStoreIds"
                            name="searchIIRReportTypeIds"
                            label={"Report Type"}
                            searchPlaceholder={"Search By Report Type"}
                            noDataLabel={"No Report Type Found"}
                            width='100%'
                            selectedValues={itemIssueReportFilters.searchReportingView !== '' ? [itemIssueReportFilters.searchReportingView] : ['1']}
                            onSelect={(selectedReportingView, currentSelection) => {
                                const selectedReportingViewIds = selectedReportingView.map((rf) => rf.id).sort().join(',');
                                setItemIssueReportFilters(previousFilters => ({ ...previousFilters, searchReportingView: selectedReportingViewIds, searchReportViewName: selectedReportingView[0].label, showTable: false }));
                            }}
                            onRemove={(selectedReportingView, currentSelection) => {
                                const selectedReportingViewIds = selectedReportingView.map((rf) => rf.id).sort().join(',');
                                setItemIssueReportFilters(previousFilters => ({ ...previousFilters, searchReportingView: selectedReportingViewIds, searchReportViewName: '', showTable: false }));
                            }}
                            ref={reportTypeFilterRef}
                        />
                    </div>
                    <div id="iirShowOnlyPurchaseItems" tabIndex={0} onClick={() => setItemIssueReportFilters(prev => ({ ...prev, showOnlyPurchaseItems: prev.showOnlyPurchaseItems === "Y" ? "N" : "Y", showTable: false }))} style={{ display: "flex", fontSize: "15px", marginRight: "20px", alignItems: "center", }}
                        onKeyDown={(e) => handlekeyDown(e, "searchIIRReportTypeIds", "generateIIR", "iirShowOnlyPurchaseItems")}>
                        <div className="checkbox" tabIndex={0}>
                            {itemIssueReportFilters.showOnlyPurchaseItems === "Y" && (
                                <span style={{ position: "relative", top: "-1px", left: "2px" }} tabIndex={0}>
                                    <FontAwesomeIcon icon={faCheck} color={"#1e59a7"} size={"sm"} />
                                </span>
                            )}
                        </div>
                        <span className="checkbox--label">Show Only Purchase Items</span>
                    </div>
                    <div className='btn--container'>
                        <div className="dashed--btn" id="generateIIR" tabIndex="0" style={{ marginLeft: '0' }} onClick={() => { generateItemIssueReportData(); }}
                            onKeyDown={(e) => { handlekeyDown(e, `iirShowOnlyPurchaseItems`, `resetBtn`, `generateIIR`) }}>Generate Report</div>
                        <div key="iir_filter_inp_frd" className="dashed--btn" onClick={() => itemIssueReportFilterReset(false)}
                            id="resetBtn"
                            tabIndex="0"
                            onKeyDown={(e) => { handlekeyDown(e, `generateIIR`, `itemIssueFromDate`, `resetBtn`) }}>Reset
                        </div>
                    </div>
                </div>
                <div key="iir_container" className="report--container">
                    {itemIssueReportFilters.showTable && (
                        itemIssueReportFilters.searchReportingView === '2' ? (
                            <ItemIssueRegisterReportDetailList itemIssueReportFilters={itemIssueReportFilters} loadData={loadData} setLoadData={setLoadData} />)
                            : (<ItemIssueRegisterReportSummaryList itemIssueReportFilters={itemIssueReportFilters} loadData={loadData} setLoadData={setLoadData} />)
                    )}
                </div>
            </div>
        </>
    )
}
export default ItemIssueRegisterReport;